var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmpathy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.667 3638.667h11.104l.214.166c-.685.356-1.31.817-1.852 1.367-2.837 2.962-2.837 7.633 0 10.595l9.387 9.667c.126.13.298.202.478.202s.353-.073.479-.202l2.856-2.935v7.806c0 .369.299.667.667.667h15.333c.369 0 .667-.298.667-.667V3654c0-.368-.298-.667-.667-.667H818.23l-.47-.365 2.108-2.168c2.837-2.962 2.837-7.634 0-10.596-2.644-2.754-6.982-2.953-9.867-.453-.7-.601-1.508-1.062-2.382-1.358l-.951-3.808v-7.918c0-.369-.299-.667-.667-.667h-15.333c-.369 0-.667.298-.667.667V3638c0 .368.298.667.667.667zm38 16v10h-14v-7.334c0-.054-.007-.109-.02-.162l-1.534-6.126 4.476 3.482c.117.091.262.14.411.14h10.667zm-19.146-13.534c.126.129.299.201.479.2.18 0 .352-.071.478-.2 1.101-1.148 2.624-1.797 4.215-1.797 1.591 0 3.114.649 4.215 1.797 2.34 2.443 2.34 6.296 0 8.739l-2.208 2.273-4.29-3.338c-.225-.175-.536-.188-.774-.033-.239.156-.352.445-.283.721l1.622 6.488-2.975 3.06-8.909-9.176c-2.337-2.442-2.337-6.292 0-8.734.586-.602 1.294-1.073 2.076-1.38l4.424 3.442c.225.174.536.187.774.032s.352-.445.282-.721l-.621-2.486c.554.29 1.058.666 1.495 1.113zm-18.188-13.8h14v7.334c0 .054.007.109.02.162l1.534 6.126-4.478-3.482c-.117-.09-.26-.14-.409-.14h-10.667v-10z",
    transform: "translate(-790 -3626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpathy);
export default __webpack_public_path__ + "static/media/icon-empathy.a80ba44a07ab24caea305ad3c7ecab85.svg";
export { ForwardRef as ReactComponent };